<template>
    <HalfCircleSpinner :animation-duration="1000" :size="size" :color="color" />
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';

export default {
    Name: 'eg-loading',
    components: {
        HalfCircleSpinner,
    },
    props: {
        color: {
            type: String,
            default: '#007BFF',
        },
        size: {
            type: Number,
            default: 80,
        },
    },
};
</script>
